import Header from "../components/Header";
import TypingTest from "../components/TypingTest";

const HomePage = () => {
    return(
        <div className="test-container">
            <Header />
            <TypingTest />
        </div>);
}
 
export default HomePage;